import {where} from "firebase/firestore";
import {sumarPropiedadColeccionWheres} from "../../Servicios/BD/Contadores/sumarPropiedadColeccionWheres";

export const obtenerTotalAhorrado = async ({idBolsillo}) => {


    let wheres =
        [
            where('idBolsillo', '==', idBolsillo),
            where('estado', '==', 'Aceptado'),
        ]

    let dox = await sumarPropiedadColeccionWheres({coleccion: 'movimientos', wheres: wheres, propiedad: 'valor'})

    if (dox.res) {
        return dox.data
    } else {
        return 0
    }
}